import React, { useEffect, useState } from 'react';
import { Drawer, DrawerContent } from "../ui/drawer";
import styles from './RestrictionPopup.module.css';
import useRestrictions from '@/src/hooks/data/useRestrictions';
import { useDispatch } from 'react-redux';
import { hideRestrictionPopup } from '@/Poker/redux/slices/lobbySlice';
import { RESTRICTION_LOCATION, RESTRICTION_PSEUDO_LOCKED } from '@/Poker/data/Constants';
import { TOURNEY_REGISTRATION_FAIR_PLAY_POLICY } from '@/Poker/data/Constants';

export default function RestrictionPopup({ open, onClose }) {
    const { userComplianceLocation, showRestriction, restrictionType } = useRestrictions();
    const dispatch = useDispatch();
    const [restrictionTitle, setRestrictionTitle] = useState('');
    const [restrictionMessage, setRestrictionMessage] = useState('');

    useEffect(() => {
        if (showRestriction) {
            setRestrictionTitle(getRestrictionTitle());
            setRestrictionMessage(getRestrictionMessage());
        }
    }, [showRestriction])

    const getRestrictionMessage = () => {
        switch (restrictionType) {
            case RESTRICTION_LOCATION:
                return 'This feature is not accessible from your location.';
            case RESTRICTION_PSEUDO_LOCKED:
                return 'Please add cash to access this feature';
            case TOURNEY_REGISTRATION_FAIR_PLAY_POLICY:
                return 'We are unable to register you to the tournament due to our fair play policy. Apologies for the inconvenience caused.';
            default:
                return 'This feature is not accessible from your location.';
        }
    }

    const getRestrictionTitle = () => {
        switch (restrictionType) {
            case RESTRICTION_LOCATION:
                return 'Location Restricted';
            case RESTRICTION_PSEUDO_LOCKED:
                return 'Pseudo Locked';
            case TOURNEY_REGISTRATION_FAIR_PLAY_POLICY:
                return 'Fair Play Policy';
            default:
                return 'Location Restricted';
        }
    }

    const handleClose = () => {
        dispatch(hideRestrictionPopup());
    };

    return (
        <Drawer dismissible={false} open={showRestriction}>
            <DrawerContent onInteractOutside={handleClose} draggable={false} showCloseButton={false} side="bottom" className={styles.container}>
                {/* Header with centered title */}
                <div className={styles.header}>
                    <h2 className={styles.title}>{restrictionTitle}</h2>
                </div>

                <div className={styles.content}>
                    <div className={styles.messageContainer}>
                        <p className={styles.messageText}>
                            {restrictionMessage}
                        </p>
                        <p className={styles.subText}>
                            {
                                userComplianceLocation
                                    ?
                                    'As per Tamil Nadu State Regulations, you cannot play cash games between 12AM to 5AM.'
                                    :
                                    'Please check back later or contact support for more information.'
                            }
                        </p>
                    </div>

                    <button
                        className={styles.actionButton}
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </DrawerContent>
        </Drawer>
    );
}
